module.exports = __webpack_public_path__ + "static/media/vanitajain.16b8f858.jpg";